"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const redux_form_1 = require("redux-form");
const bottom_buttons_1 = __importDefault(require("../bottom-buttons"));
const preferences_form_fields_1 = __importDefault(require("./preferences-form-fields"));
class PreferencesSettings extends React.Component {
    onSubmit = (values) => {
        const { online, submitPreferencesForm, dirty } = this.props;
        if (online && dirty) {
            return submitPreferencesForm(values);
        }
        else {
            // an un-edited form needs to have a clickable button that needs to do nothing.
            // Since it's a form button, onSubmit will be called. We can just return a
            // good promise so the form resolves and sets submitting: false
            return Promise.resolve({});
        }
    };
    componentWillUnmount() {
        const { showSaveNeeded, dirty, submitting, reset, handleSubmit, history } = this.props;
        if (dirty) {
            const saveNeededData = {
                message: 'You have unsaved preference changes',
                saving: submitting,
                cancel: reset,
                onSave: handleSubmit(this.onSubmit),
                onSaveError: () => history.replace('/settings/preferences'),
            };
            return showSaveNeeded(saveNeededData);
        }
    }
    render() {
        const { handleSubmit, submitting, reset } = this.props;
        return (React.createElement("form", { id: "preferences", onSubmit: handleSubmit(this.onSubmit), noValidate: true },
            React.createElement("div", { id: "prefrences", className: "settings-section" },
                React.createElement("div", { className: "Panel" },
                    React.createElement("div", { className: "Panel-header" },
                        React.createElement("h3", { className: "Panel-title" }, "Preferences")),
                    React.createElement("div", { className: "Panel-body" },
                        React.createElement(preferences_form_fields_1.default, null))),
                React.createElement(bottom_buttons_1.default, { id: "preferences-buttons", submitting: submitting, onCancel: reset, onSubmit: handleSubmit(this.onSubmit) }))));
    }
}
exports.default = (0, redux_form_1.reduxForm)({
    form: 'preferences-settings',
    enableReinitialize: true, // to load initialValues
})(PreferencesSettings);
